(ns beicon.impl.rxjs-operators
  (:require ["rxjs/operators" :as rxop]))

(goog/exportSymbol "rxjsOperators" rxop)
